import {Box, Button, Dialog, Heading, Portal, StackSeparator, VStack} from '@chakra-ui/react';
import {DialogCloseButton} from './ui/dialog-close-button';
import {useReleaseNotes} from '../releaseNotes/useReleaseNotes';
import {Markdown} from './Markdown';

/** "What's new": the release notes the user hasn't seen yet, shown once after an update. */
export function VersionPopup() {
    const {notes, isOpen, dismiss} = useReleaseNotes();

    return (
        <Dialog.Root
            open={isOpen}
            onOpenChange={(e) => {
                if (!e.open) dismiss();
            }}
            size="lg"
            scrollBehavior="inside"
        >
            <Portal>
            <Dialog.Backdrop/>
            <Dialog.Positioner>
            <Dialog.Content>
                <Dialog.Header><Dialog.Title>Újdonságok</Dialog.Title></Dialog.Header>
                <DialogCloseButton/>
                <Dialog.Body>
                    <VStack align="stretch" gap={5} separator={<StackSeparator/>}>
                        {notes.map((note) => (
                            <Box key={note.version}>
                                <Heading as="h3" size="md" mb={3}>{note.version}</Heading>
                                <Markdown source={note.text}/>
                            </Box>
                        ))}
                    </VStack>
                </Dialog.Body>
                <Dialog.Footer>
                    <Button colorPalette="blue" onClick={dismiss}>Bezárás</Button>
                </Dialog.Footer>
            </Dialog.Content>
            </Dialog.Positioner>
            </Portal>
        </Dialog.Root>
    );
}
